module.exports = "/packs/images/svg/ireland/facilities/trampoline~76e424aa8a7c2b908dc08c2819491c38.svg";